/* nm-rutinas.js · acordeón de rutinas A–D (una abierta a la vez). Se carga solo en la portada. */
(function () {
  'use strict';
  var box = document.getElementById('rt'); if (!box) return;
  var cards = Array.prototype.slice.call(box.querySelectorAll('.rt-card'));
  function heads() { return cards.map(function (c) { return c.querySelector('.rt-head'); }); }
  function select(i, opts) {
    opts = opts || {};
    cards.forEach(function (c, k) {
      var on = k === i; c.classList.toggle('on', on);
      c.querySelector('.rt-head').setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    if (opts.focus) cards[i].querySelector('.rt-head').focus();
    if (window.ScrollTrigger && window.ScrollTrigger.refresh) setTimeout(function () { window.ScrollTrigger.refresh(); }, 700);
  }
  NM.selectRoutine = select;
  cards.forEach(function (c, i) {
    c.querySelector('.rt-head').addEventListener('click', function () { if (!c.classList.contains('on')) select(i); });
  });
  /* teclado: flechas / Inicio / Fin se mueven entre las cabeceras (patrón de acordeón WAI-ARIA) */
  box.addEventListener('keydown', function (e) {
    var h = heads(), k = h.indexOf(document.activeElement); if (k < 0) return;
    var n = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (k + 1) % h.length;
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (k - 1 + h.length) % h.length;
    else if (e.key === 'Home') n = 0; else if (e.key === 'End') n = h.length - 1;
    if (n !== null) { e.preventDefault(); h[n].focus(); }
  });
})();
